import { render, staticRenderFns } from "./BenefitSection.vue?vue&type=template&id=4bd80bd2"
import script from "./BenefitSection.vue?vue&type=script&lang=js"
export * from "./BenefitSection.vue?vue&type=script&lang=js"
import style0 from "./BenefitSection.vue?vue&type=style&index=0&id=4bd80bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports